/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

import CampaignConstants from 'constants/CampaignConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'
import { openSidebar } from 'utils/DrifttHelpers'
import { TYPES, STATUS } from 'components/campaign/constants'

const CampaignQueries = Marty.createQueries({
  id: 'CampaignQueries',

  createCampaign(body, requestId) {
    this.dispatch(CampaignConstants.CAMPAIGN_CREATE_STARTING, requestId)

    const promise = this.app.sources.CampaignAPI.createCampaign(body)

    promise.then(res => {
      if (res.status === 200) {
        const campaign = res.body
        this.dispatch(CampaignConstants.CAMPAIGN_CREATE_DONE, campaign, requestId)

        const notification = {
          content: `You've created a new campaign: ${ campaign.name }`,
          displayTime: 5000
        }
        // Don't include a URL for Chat campaigns (which have no reports page)
        if (campaign.type !== TYPES.chat.serverType) {
          notification.viewLinkTo = {
            pathname: `/campaigns/${campaign.id}`
          }
        }

        return this.app.actions.NotificationActions.pushNotification(notification)
      } else if (res.status === 403) {
        this.app.actions.NotificationActions.pushNotification({
          content: "Before you can send email campaigns you need to be verified by the Drift team",
          actioNode: <button className="dsg-SmallButton" onClick={openSidebar}>
            Chat with us
          </button>,
          sticky: true,
          variant: 'red'
        })
        return this.dispatch(CampaignConstants.CAMPAIGN_CREATE_FAILED, requestId, res)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_CREATE_FAILED, requestId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_CREATE_FAILED, requestId, error)
    })
  },

  updateCampaign(id, update) {
    this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_STARTING, id, update)

    const promise = this.app.sources.CampaignAPI.updateCampaign(id, update)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_DONE, id, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_FAILED, id, update, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_FAILED, id, update, error)
    })
  },

  updateCampaignOld(id, update) {
    this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_STARTING, id, update)

    const promise = this.app.sources.CampaignAPI.updateCampaignOld(id, update)

    promise.then(res => {
      if (res.status === 200) {
        this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_DONE, id, res.body)
        if (update.status === STATUS.NOT_RUNNING.key) {
          return this.app.actions.NotificationActions.pushNotification({
            content: 'Campaign has been paused'
          })
        } else if (update.status === STATUS.RUNNING.key) {
          return this.app.actions.NotificationActions.pushNotification({
            content: 'Campaign has been started'
          })
        }
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_FAILED, id, update, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_UPDATE_FAILED, id, update, error)
    })
  },

  fetchCampaigns() {
    const promise = this.app.sources.CampaignAPI.fetchCampaigns()

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGNS_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGNS_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGNS_FETCH_FAILED, error)
    })
  },

  fetchCampaign(id, accessToken = null) {
    const promise = this.app.sources.CampaignAPI.fetchCampaign(id, accessToken)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGN_FETCH_DONE, id, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_FETCH_FAILED, id, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_FETCH_FAILED, id, error)
    })
  },

  fetchCampaignsForEndUserId(endUserId) {
    const promise = this.app.sources.CampaignAPI.fetchCampaignsForEndUserId(endUserId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(
          CampaignConstants.CAMPAIGNS_FOR_END_USER_FETCH_DONE,
          endUserId,
          res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGNS_FOR_END_USER_FETCH_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGNS_FOR_END_USER_FETCH_FAILED, error)
    })
  },

  fetchCampaignResults(campaignId) {
    const promise = this.app.sources.CampaignAPI.fetchCampaignResults(campaignId)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGN_RESULTS_FETCH_DONE, campaignId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_RESULTS_FETCH_FAILED, campaignId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_RESULTS_FETCH_FAILED, campaignId, error)
    })
  },

  fetchCampaignMembers(campaignId, query) {
    const promise = this.app.sources.CampaignAPI.fetchCampaignMembers(campaignId, query)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGN_MEMBERS_FETCH_DONE, campaignId, query, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_MEMBERS_FETCH_FAILED, campaignId, query, res)
      }
    })

    promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_MEMBERS_FETCH_FAILED, campaignId, query, error)
    })

    promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_RESPONSES_FETCH_FAILED, error)
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_RESPONSES_FETCH_FAILED, error)
    })
  },

  deleteCampaignForCampaignId(campaignId) {
    this.dispatch(CampaignConstants.CAMPAIGN_DELETE_STARTING, campaignId)

    const promise = this.app.sources.CampaignAPI.updateCampaignOld(campaignId, { status: 'ARCHIVED' })
    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(CampaignConstants.CAMPAIGN_DELETE_DONE, campaignId)
      } else {
        captureResponseException(res)
        return this.dispatch(CampaignConstants.CAMPAIGN_DELETE_FAILED, campaignId, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(CampaignConstants.CAMPAIGN_DELETE_FAILED, campaignId, error)
    })
  }

})

export default CampaignQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/CampaignQueries.js